<template>
<div>荣誉</div>
</template>

<script>
export default {
  name: "honor"
}
</script>

<style scoped>

</style>
